














































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import ContactLensImageTypeSwitcher from '@/components/organisms/item-list/ContactLensImageTypeSwitcher.vue'

import Util, { ItemlistUrlQueryParameter } from '../../../modules/util'
import Sort from './Sort.vue'

const HEADER_SELECTOR = '#vue-ec-header'

@Component({
  components: {
    Sort,
    ContactLensImageTypeSwitcher,
  },
})
export default class ItemListHeaderBar extends Vue {
  @Prop({ required: true })
  container: Element

  @Prop({ required: true })
  showImageSwitcher: boolean

  @Prop({ required: true })
  hasItems: boolean

  @Prop({ required: true })
  hasKeywordSearch: boolean

  isFixed: boolean = false
  headerHeight: number = 0
  elementHeight: number = 0
  containerLeft: number = 0
  containerWidth: number = 0

  private queries: ItemlistUrlQueryParameter = {}

  mounted() {
    this.queries = Util.convertItemlistUrlParamsToAssociativeArray()
    this.updateHeaderHeight()
    this.updateContainerRect()
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    window.addEventListener('resize', this.handleResize, { passive: true })
    this.$nextTick(() => this.updateFixedState())
  }

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
  }

  get wrapperStyle(): object {
    return this.isFixed ? { height: `${this.elementHeight}px` } : {}
  }

  get innerStyle(): object {
    if (!this.isFixed) return {}

    return {
      position: 'fixed',
      top: `${this.headerHeight}px`,
      left: `${this.containerLeft}px`,
      width: `${this.containerWidth}px`,
    }
  }

  get filterUrl(): string {
    const brand = this.$route.params.brand_english_name

    return brand ? `/${brand}/itemlist/filter` : '/itemlist/filter'
  }

  get filterFormValues(): Array<{ key: string; value: string }> {
    return Object.entries(this.queries)
      .filter(([key, value]) => key !== 'from' && value != null)
      .map(([key, value]) => ({ key, value: String(value) }))
  }

  private handleScroll() {
    this.updateFixedState()
  }

  private handleResize() {
    this.updateHeaderHeight()
    this.updateContainerRect()
    this.updateFixedState()
  }

  private updateFixedState() {
    const el = this.$el as HTMLElement
    if (!el) return
    const scrollTop = window.pageYOffset
    const elementTop = el.getBoundingClientRect().top + scrollTop
    if (scrollTop + this.headerHeight >= elementTop) {
      if (!this.isFixed) {
        this.elementHeight = el.offsetHeight
      }
      this.isFixed = true
    } else {
      this.isFixed = false
    }
  }

  private updateHeaderHeight() {
    const header = document.querySelector(HEADER_SELECTOR)
    this.headerHeight = header ? (header as HTMLElement).offsetHeight : 0
  }

  private updateContainerRect() {
    const rect = (this.container as HTMLElement).getBoundingClientRect()
    this.containerLeft = rect.left
    this.containerWidth = rect.width
  }
}
